const namespace = 'app/components/SearchPanel';

export const SEARCH_START = `${namespace}/SEARCH_START`;
export const SEARCH_CHUNK_SUCCESS = `${namespace}/SEARCH_CHUNK_SUCCESS`;
export const SEARCH_CHUNK_ERROR = `${namespace}/SEARCH_CHUNK_ERROR`;
export const SEARCH_CLEAR = `${namespace}/SEARCH_CLEAR`;
export const TOGGLE_CHAPTER = `${namespace}/TOGGLE_CHAPTER`;

export const SUGGEST_START = `${namespace}/SUGGEST_START`;
export const SUGGEST_SUCCESS = `${namespace}/SUGGEST_SUCCESS`;
export const SUGGEST_ERROR = `${namespace}/SUGGEST_ERROR`;
export const SET_SHOW_SUGGESTIONS = `${namespace}/SET_SHOW_SUGGESTIONS`;

export const LOAD_HISTORY = `${namespace}/LOAD_HISTORY`;
export const ADD_HISTORY_ENTRY = `${namespace}/ADD_HISTORY_ENTRY`;
export const REMOVE_HISTORY_ENTRY = `${namespace}/REMOVE_HISTORY_ENTRY`;
export const CLEAR_HISTORY = `${namespace}/CLEAR_HISTORY`;

export const RESET_SEARCH_STORE = `${namespace}/RESET_SEARCH_STORE`;

// BACW-554 — backend indexing trigger
export const INDEXING_START = `${namespace}/INDEXING_START`;
export const INDEXING_DONE = `${namespace}/INDEXING_DONE`;
export const INDEXING_ERROR = `${namespace}/INDEXING_ERROR`;
